import { useQuery } from '@tanstack/react-query';

import getCertificates from '~apis/certificates/getCertificates';

export const USE_GET_CERTIFICATES_QUERY = {
  default: (companyId: string) => ['certificates', companyId],
};
export default function useCertificatesQuery(companyId?: string) {
  return useQuery(
    USE_GET_CERTIFICATES_QUERY.default(companyId as string),
    () => getCertificates(companyId as string),
    {
      enabled: !!companyId,
      cacheTime: 0,
    },
  );
}
